import React from 'react';

import { Container, Row, Col, Table } from 'react-bootstrap';


const levels = [
  { level: 1, name: 'BRONZE DS', reward: '6.5%', amount: '15,000' },
  { level: 2, name: 'SILVER DS', reward: '5%', amount: '30,000' },
  { level: 3, name: 'GOLD DS', reward: '4%', amount: '60,000' },
  { level: 4, name: 'PLATINUM DS', reward: '2.5%', amount: '120,000' },
  { level: 5, name: 'EMERALD DS', reward: '2%', amount: '240,000' },
  { level: 6, name: 'TOPAZ DS', reward: '1.5%', amount: '480,000' },
  { level: 7, name: 'RUBI STAR DS', reward: '1.25%', amount: '960,000' },
  { level: 8, name: 'SAPPHIRE DS', reward: '1%', amount: '1,920,000' },
  { level: 9, name: 'STAR SAPPHIRE DS', reward: '0.80%', amount: '3,840,000' },
  { level: 10, name: 'DIAMOND DS', reward: '0.60%', amount: '7,680,000' },
  { level: 11, name: 'BLUE DIAMOND DS', reward: '0.45%', amount: '15,360,000' },
  { level: 12, name: 'BLACK DIAMOND DS', reward: '0.40%', amount: '30,720,000' },
];

const Earningplan = () => {
  return (
    <>
    <h4 className="mb-3 text-success text-center fw-bold">Earning Plan</h4>
    <div className="dashboard-container d-flex">

      <div className="main-dashboard flex-grow-1 p-4">
      

        <Container fluid>
          <Row>
            <Col xs={12}>
              <div className="table-responsive">
                <Table striped bordered hover responsive className="text-center">
                  <thead className="table-dark">
                    <tr>
                      <th>Sr. No</th>
                      <th>Level Name</th>
                      <th>Reward %</th>
                      <th>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {levels.map((item) => (
                      <tr key={item.level}>
                        <td>{item.level}</td>
                        <td>{item.name}</td>
                        <td>{item.reward}</td>
                        <td>{item.amount}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
    </>
  );
};

export default Earningplan;
